var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container-card"},[_c('FiltroRelatorios',{on:{"selectedFilters":function($event){_vm.filters = $event}}}),_c('Relatorios',{attrs:{"filters":_vm.filters,"list":_vm.menus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }